"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
function default_1(props) {
    return react_1.default.createElement(core_1.SvgIcon, __assign({}, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", height: "24px", viewBox: "-10 -3 24 24" },
            react_1.default.createElement("path", { d: "M2.000,17.998 C0.895,17.998 -0.000,17.103 -0.000,15.999 C-0.000,14.894 0.895,13.998 2.000,13.998 C3.104,13.998 4.000,14.894 4.000,15.999 C4.000,17.103 3.104,17.998 2.000,17.998 ZM2.000,6.998 C3.104,6.998 4.000,7.894 4.000,8.998 C4.000,10.103 3.104,10.998 2.000,10.998 C0.895,10.998 -0.000,10.103 -0.000,8.998 C-0.000,7.894 0.895,6.998 2.000,6.998 ZM2.000,-0.001 C3.104,-0.001 4.000,0.894 4.000,1.998 C4.000,3.103 3.104,3.999 2.000,3.999 C0.895,3.999 -0.000,3.103 -0.000,1.998 C-0.000,0.894 0.895,-0.001 2.000,-0.001 Z" })));
}
exports.default = default_1;
